export const CLIENT_PLAYER_STATUS = 'client-player-status';

export default interface PlayerStatus
{
    bot: boolean
}
